import React from 'react'
import MainBanner from '../../components/MainComponents/MainBanner'
import { bannerServiceImage, mainTitle, serviceBanners, servicesImages } from '../../config'
import Footer from '../../components/MainComponents/Footer';
import { Link } from 'react-router-dom';
import HealthService from '../../components/ServiceComponents/HealthService';
import { services } from '../../utils/Data';
import { newServices } from '../../utils/NewData';
import ContactHeader from '../../components/MainComponents/ContactHeader';



const ServicesPage = () => {
  return (
    <div>
      <ContactHeader/>
        <MainBanner
        
         bannerTitle={mainTitle}
         banenrHeadline={"Comprehensive Care for Every Need"}
         showButton = {false}
         mainBannerImages = {[serviceBanners.bannerOne,serviceBanners.bannerTwo,serviceBanners.bannerThree]}
         bannerDescription={"Explore Our Wide Range of Specialized Services Designed to Enhance Your Well-being and Quality of Life"}
        />
      <HealthService services = {newServices}/>
    <Footer/>
    </div>
  )
}

export default ServicesPage